import { createActions } from 'redux-actions'

export const { ui } = createActions({
  UI: {
    SET_MODE: (mode) => ({ mode }),
    SET_LENGUAGE: (lenguage) => ({ lenguage })
  }
})
